<script lang="ts">
  interface Props {
    avatarId: number;
    /** `fill` takes the width of its container and stays square. */
    size?: 'md' | 'sm' | 'game' | 'fill';
    tone?: 'p1' | 'p2' | 'neutral';
    state?: 'normal' | 'active' | 'hit' | 'empty';
    label?: string;
  }

  let {
    avatarId,
    size = 'md',
    tone = 'neutral',
    state = 'normal',
    label = `Avatar ${avatarId}`,
  }: Props = $props();

  const palette = $derived(
    tone === 'p1'
      ? 'cyan'
      : tone === 'p2'
        ? 'mag'
        : ['cyan', 'mag', 'grn', 'yel'][Math.abs(avatarId) % 4],
  );
  const symbol = $derived(
    state === 'hit'
      ? 'av-hit'
      : state === 'empty'
        ? 'av-empty'
        : state === 'active' && (palette === 'cyan' || palette === 'mag')
          ? `av-${palette}-on`
          : `av-${palette}`,
  );
</script>

<div
  class="avatar avatar--{size} {tone === 'neutral' ? '' : `avatar--${tone}`} {state === 'hit'
    ? 'avatar--hit'
    : ''} {state === 'empty' ? 'avatar--empty' : ''}"
>
  <svg viewBox="0 0 9 9" shape-rendering="crispEdges" role="img" aria-label={label}>
    <use href="#{symbol}"></use>
  </svg>
</div>
